import * as signalR from '@microsoft/signalr';
import { apiUrl } from '../../../../config';

export default {
  data: vm => ({
    popToken: vm.$route.query.popToken,
    connection: null,
    isLogoutBeaconSent: false
  }),
  created () {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${apiUrl}/hub/notification?token=${this.popToken}`)
      .withAutomaticReconnect()
      .build();

    this.start();

    window.addEventListener('pagehide', () => this.disconnectWS('pagehide'));
  },
  methods: {
    async start () {
      try {
        await this.connection.start();
        await this.connection._sendMessage(this.connection._cachedPingMessage);
      } catch (err) {
        console.log(err);
        setTimeout(() => { this.start() }, 5000);
      }
    },
    disconnectWS (reason) {
      if (reason === 'pagehide' && !this.isLogoutBeaconSent) {
        this.isLogoutBeaconSent = true;
        navigator.sendBeacon(`${apiUrl}/session/logout?reason=${reason}&token=${this.popToken}`);
      }
    }
  }
}
